// extracted by mini-css-extract-plugin
module.exports = {"ctfPageCopy":"join-page_ctfPageCopy__T359I","benefitsImage":"join-page_benefitsImage__D5dGv","benefitsImageGradients":"join-page_benefitsImageGradients__wKiAl"};